import { v4 } from 'uuid';
import { CheckoutPlanDisplay } from './checkout-plan-display';
import { Model } from './model';
import { Status } from './status';

export function createMockPolicy(overrides: Partial<Model> = {}): Model {
  const id = overrides.id ?? `pol_${v4().replace(/-/g, '')}`;
  return {
    id,
    referenceId: null,
    created: new Date(),
    modified: new Date(),
    deleted: null,
    publishedDate: null,
    policyNumber: 'HGP-20221234',
    title: 'Mock Policy',
    friendlyTitle: 'Mock Friendly Title',
    icon: 'mock-icon',
    tagline: 'Mock Tagline',
    description: 'A mock policy for testing.',
    tags: [],
    validity: '1 year',
    welcomeEmailDelayHours: 1,
    status: Status.PUBLISHED,
    propertySetId: 'mock-property-set-id',
    propertySet: undefined,
    claimWaitingPeriod: null,
    plans: [],
    coverages: overrides.coverages ?? [
      {
        id: `cov_${v4().replace(/-/g, '')}`,
        title: 'Mock Coverage',
        description: 'Mock coverage description',
        order: 0,
        created: new Date(),
        modified: new Date(),
        deleted: null,
        referenceId: null,
        group: 'BASE',
        inclusions: null,
        exclusions: null,
        policyId: id, // use generated policy id
      },
    ],
    claimLifecycleSteps: [],
    emails: [],
    cancelationRules: [],
    termsAndConditionsId: null,
    termsAndConditions: undefined,
    coverageSummaryId: null,
    coverageSummary: undefined,
    terms: [
      {
        id: `trm_${v4().replace(/-/g, '')}`,
        duration: 12,
        paymentSchedules: [],
        title: 'Mock Term',
        order: 0,
      },
    ],
    requiresWarrantyActivation: false,
    allowMarkup: false,
    checkClaimEligibility: false,
    checkoutPlanDisplay: CheckoutPlanDisplay.TERM_FIRST,
    customerPortalConfig: {
      selfServeClaims: true,
      claimsPlaceholder: null,
    },
    order: 0,
    ...overrides, // Allow customization
  };
}
